$(document).on("click", 'button[data-bs-toggle="modal"]', function () {
  var id = $(this).attr("data-bs-target"),
    type = $(this).attr("data-donation-type");

  $(id).modal();
  $(id).addClass("modal-" + type);

  /** Dynamically select cause so that it can just be hidden */
  var $cause = $(id).find(".causes-dropdown .dropdown-item");
  $cause.addClass("selected");
  $(id)
    .find('input[name="wc-donation-cause"]')
    .val($cause.attr("data-name"))
    .trigger("change");

  /** Dynamically select second option */
  var $donationWrapper = $(id).find(".donation-wrapper");

  $donationWrapper.each(function () {
    var $secondItem = $(this)
        .find(".wc-label-radio")
        .eq(1)
        .find('input[name="wc_radio_price"]'),
      value = $secondItem.val();

    $secondItem.prop("checked", true).trigger("change");

    $(this)
      .find('input[name="wc-donation-price"]')
      .val(value)
      .trigger("change");
  });
});

$('[id^="donationModal"]').on("hidden.bs.modal", function (e) {
  $(e.currentTarget).removeClass(function (index, className) {
    return (className.match(/(^|\s)modal-\S+/g) || []).join(" ");
  });
});

$(".donation-wrapper").each(function () {
  var $footerContent = $(this).find(".footer-content"),
    $submitButton = $(this).find(".button.wc-donation-f-submit-donation");

  $footerContent.insertBefore($submitButton);
});

$(".donation-type-switcher").on("click", function () {
  $(this).parents(".modal").find(".donation-wrapper").show();
  $(this).parents(".donation-wrapper").hide();
});

if ($(".donation-wrapper .wc-donation-f-donation-other-value").length > 0) {
  $(".donation-wrapper .wc-donation-f-donation-other-value").each(function () {
    $(this).attr("placeholder", "Enter amount");
  });
}

$(".donation-product .pewc-radio-option-text").each(function () {
  var content = $(this).html();
  // Use regex to match the first £ followed by numbers
  var updatedContent = content.replace(
    /(£\d+(?:\.\d{2})?)/,
    '<span class="custom-label-wrap">$1</span>'
  );
  $(this).html(updatedContent);
});
